import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type {
  FindProductByParamsResponse,
  ProductApi,
  ProductRequestParams,
} from './product-api';

import type { OrderItemCategory } from '..';
import type { Product } from '../product';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewayProductApi implements ProductApi {
  scpClient: ScpClient;
  host: string;

  constructor({ scpClient, host }: Params) {
    this.scpClient = scpClient;
    this.host = host;
  }

  getCategories(): Promise<OrderItemCategory[]> {
    return this.makeRequest<OrderItemCategory[]>({
      method: 'get-list',
      service: 'public/categories',
    }).then((response) => response.payload);
  }

  findProductByParams(
    params: ProductRequestParams
  ): Promise<FindProductByParamsResponse> {
    return this.makeRequest<Product>({
      version: 'v2',
      method: 'get-by-parameters',
      service: 'public/products',
      payload: params,
    }).then((response) => response.payload);
  }

  private makeRequest<T>(
    params: Partial<RequestParams> & { method: string; service: string }
  ) {
    return this.scpClient.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
